import React from 'react';
import './SpotFuturesToggle.css';

export function hasFuturesEnabled() {
    return localStorage.getItem('hasFutures') === 'true';
}

/**
 * props:
 * - value: 'spot' | 'futures'
 * - onChange: (value: 'spot' | 'futures') => void
 * - size: 'sm' | 'md'
 * - disabled: boolean
 * - className: string
 * - showLabel: boolean
 * - inlineLabel: boolean
 */
function SpotFuturesToggle(props) {
    const size = props.size || 'md';
    const value = props.value || 'spot';

    if (!hasFuturesEnabled()) return null;

    function handleSelect(nextValue) {
        if (props.disabled || nextValue === value) return;
        if (props.onChange) props.onChange(nextValue);
    }

    const wrapperClass = [
        'spot-futures-toggle-field',
        props.inlineLabel ? 'spot-futures-toggle-field--inline' : '',
        props.className || '',
    ].filter(Boolean).join(' ');

    return (
        <div className={wrapperClass}>
            {props.showLabel && (
                <span className={`spot-futures-toggle-label ${props.inlineLabel ? 'spot-futures-toggle-label--inline' : ''}`}>
                    Market
                </span>
            )}
            <div
                className={`spot-futures-toggle spot-futures-toggle--${size}`}
                role="group"
                aria-label="Select market type"
            >
                <button
                    type="button"
                    data-market="spot"
                    className={`spot-futures-toggle-btn ${value === 'spot' ? 'active' : ''}`}
                    aria-pressed={value === 'spot'}
                    disabled={props.disabled}
                    onClick={() => handleSelect('spot')}
                >
                    <span className="spot-futures-toggle-dot" aria-hidden="true" />
                    Spot
                </button>
                <button
                    type="button"
                    data-market="futures"
                    className={`spot-futures-toggle-btn ${value === 'futures' ? 'active' : ''}`}
                    aria-pressed={value === 'futures'}
                    disabled={props.disabled}
                    onClick={() => handleSelect('futures')}
                >
                    <span className="spot-futures-toggle-dot" aria-hidden="true" />
                    Futures
                </button>
            </div>
        </div>
    );
}

export default SpotFuturesToggle;